module.exports = __webpack_public_path__ + "static/img/66.fee5cf7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/66.png
// module id = yG4A
// module chunks = 1